import classNames from 'classnames';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';

import './ContainerOverflow.css';

export interface ContainerOverflowProps {
    cls?: string;
    children: React.ReactNode;
}

/**
 * @deprecated этот компонент будет удален
 * Вместо него используйте нативный скролл
 */
export const ContainerOverflow = ({
    children,
    cls
}: ContainerOverflowProps) => (
    <div className={classNames(Bem.cls('container-overflow'), cls)}>
        <div
            className={Bem.cls({
                block: 'container-overflow',
                elem: 'scroll-container'
            })}
        >
            <div className={Bem.cls('container-overflow', 'content')}>
                {children}
            </div>
        </div>
    </div>
);
